import axios from "axios";
import { getTokenValue } from "../../utils/getToken";

export const getChatBotResponse = async (URL: string, data: any) => {
  const token = getTokenValue();

  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  return await axios.post(
    URL,
    {
      messages: data,
    },
    {
      headers,
    }
  );
};

export const getFAQuestions = async (URL: string) => {
  const token = getTokenValue();

  const headers = token ? { Authorization: token } : {};

  try {
    const result = await axios.get(URL, { headers });
    if (result.data.success) {
      return result.data.response?.slice(0, 3); // corrected 'slive' to 'slice'
    } else {
      return undefined;
    }
  } catch (error: unknown) {
    return undefined;
  }
};
